module.exports = __webpack_public_path__ + "img/haut-und-haarpflege_kachel_ALOEVIA.be4c241e.png";